/* T-0222 Marketing homepage V2. Vanilla JS, no dependencies.
   Products are rendered by Liquid from their own Shopify data; this file only wires behaviour:
   postcode check, swipe progress, video play/pause + sound, the box builder (Document #5 tiers) and the combo add. */
(function () {
  'use strict';
  var root = document.querySelector('.mk2');
  if (!root) return;
  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('mk2-data').textContent); } catch (e) {}
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var money = function (c) { return '$' + (Math.round(c) / 100).toFixed(2); };

  /* ---------- postcode: one swappable function (Document #5 section 1: production = the zone API, B6) ---------- */
  function serviceablePostcode(p) {
    var n = parseInt(p, 10);
    if ((n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920) || (n >= 200 && n <= 299)) return 'the ACT';
    if (n >= 2000 && n <= 2999) return 'NSW';
    if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
    if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
    if (n >= 6000 && n <= 6999) return 'WA';
    return null;
  }
  var pcIn = $('#mk2-pc-in'), pcBtn = $('#mk2-pc-btn'), pcMsg = $('#mk2-pc-msg');
  function checkPostcode() {
    if (!pcIn || !pcMsg) return;
    var p = (pcIn.value || '').replace(/\D/g, '').slice(0, 4); pcIn.value = p;
    pcMsg.hidden = false; pcMsg.className = 'mk2-pc-msg'; pcMsg.textContent = '';
    if (!/^\d{4}$/.test(p)) { pcMsg.className += ' bad'; pcMsg.textContent = 'Pop in a 4-digit postcode to check.'; return; }
    var st = serviceablePostcode(p);
    if (st) { pcMsg.textContent = 'Your postcode is in ' + st + '. We’ll confirm delivery to your suburb and your delivery day at checkout.'; return; }
    pcMsg.className += ' bad';
    pcMsg.appendChild(document.createTextNode('We are not currently servicing your area yet — follow our '));
    var ig = document.createElement('a'); ig.href = 'https://www.instagram.com/thr1ve/'; ig.target = '_blank'; ig.rel = 'noopener'; ig.textContent = 'Instagram';
    pcMsg.appendChild(ig); pcMsg.appendChild(document.createTextNode(' for updates!'));
  }
  if (pcBtn) pcBtn.addEventListener('click', checkPostcode);
  if (pcIn) pcIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkPostcode(); } });

  /* ---------- swipe progress ---------- */
  function measureSwipe() {
    $$('.mk2-swipe').forEach(function (sw) {
      var bar = sw.parentNode.querySelector('.mk2-bar i'); if (!bar || !sw.scrollWidth) return;
      var w = Math.max(10, Math.min(100, (sw.clientWidth / sw.scrollWidth) * 100));
      var max = sw.scrollWidth - sw.clientWidth;
      var l = max > 0 ? (sw.scrollLeft / max) * (100 - w) : 0;
      bar.style.width = w + '%'; bar.style.left = l + '%';
    });
  }
  $$('.mk2-swipe').forEach(function (sw) { sw.addEventListener('scroll', measureSwipe, { passive: true }); });
  window.addEventListener('resize', measureSwipe);
  window.addEventListener('load', measureSwipe);
  measureSwipe();

  /* ---------- videos: muted loops that only play while visible; Pause control; one clip with sound ---------- */
  var vids = $$('video[data-mk2-vid]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var held = reduce;
  vids.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; });
  function playV(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && !held) playV(e.target); else e.target.pause(); });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  } else if (!held) { vids.forEach(playV); }
  var heroCopy = $('.mk2-hero-copy');
  if (vids.length && heroCopy) {
    var tg = document.createElement('button');
    tg.type = 'button'; tg.className = 'mk2-btn mk2-btn-dark mk2-sm'; tg.style.alignSelf = 'flex-start';
    tg.setAttribute('aria-pressed', String(held)); tg.textContent = held ? 'Play videos' : 'Pause videos';
    tg.addEventListener('click', function () {
      held = !held; tg.setAttribute('aria-pressed', String(held)); tg.textContent = held ? 'Play videos' : 'Pause videos';
      vids.forEach(function (v) { if (held) v.pause(); else if (v.getBoundingClientRect().top < window.innerHeight && v.getBoundingClientRect().bottom > 0) playV(v); });
    });
    heroCopy.appendChild(tg);
  }
  $$('.mk2-snd').forEach(function (b) {
    b.addEventListener('click', function () {
      var target = document.getElementById(b.getAttribute('data-for'));
      var turnOn = b.getAttribute('aria-pressed') !== 'true';
      $$('.mk2-snd').forEach(function (o) {
        var v = document.getElementById(o.getAttribute('data-for'));
        var on = turnOn && o === b;
        o.setAttribute('aria-pressed', String(on)); o.textContent = on ? 'Sound on' : 'Tap for sound';
        if (v) v.muted = !on;
      });
      if (turnOn && target && !held) playV(target);
    });
  });

  /* ---------- box builder: Document #5 section 4 tiers (read from the tier buttons Liquid rendered) ---------- */
  var BASE = Number(DATA.baseMeal) || 12.95;
  var S = { freq: 'Weekly', size: 14, supp: null };
  var tiers = $$('.mk2-tier'), freqs = $$('.mk2-freq');
  function pmOf(n) { var t = tiers.filter(function (x) { return Number(x.getAttribute('data-n')) === n; })[0]; return t ? Number(t.getAttribute('data-pm')) : BASE; }
  function renderBox() {
    var one = S.freq === 'One-time';
    if (one && S.size === 25) S.size = 18; /* 25 is subscriber-only (Document #5 section 4) */
    freqs.forEach(function (b) { var on = b.getAttribute('data-freq') === S.freq; b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on)); });
    tiers.forEach(function (b) {
      var n = Number(b.getAttribute('data-n')), on = n === S.size, off = one && n === 25;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on)); b.disabled = off;
    });
    var pm = pmOf(S.size), meals = Math.round(pm * 100) * S.size;
    var suppC = S.supp ? Number(S.supp.price) : 0;
    $('#mk2-sum-title').textContent = S.size + ' meals, ' + S.freq.toLowerCase();
    $('#mk2-sum-meals').textContent = S.size + ' meals × ' + money(Math.round(pm * 100));
    $('#mk2-sum-mealstotal').textContent = money(meals);
    var row = $('#mk2-sum-supp-row'); row.hidden = !S.supp;
    if (S.supp) { $('#mk2-sum-supp').textContent = '+ ' + S.supp.name; $('#mk2-sum-suppprice').textContent = money(suppC); }
    var ship = $('#mk2-sum-ship'); ship.textContent = one ? 'Up to $19.95' : 'Free'; ship.className = one ? '' : 'g';
    $('#mk2-sum-total').textContent = money(meals + suppC) + (one ? ' + shipping' : '');
    $('#mk2-sum-note').textContent = one ? 'Final shipping is calculated from your delivery address.' : 'Renews ' + S.freq.toLowerCase() + '. Edit, skip or cancel before the Tuesday 9:00pm cut-off. No lock-in.';
    var go = $('#mk2-continue');
    if (go) { var u = go.getAttribute('data-base') || '#'; go.href = u + (u.indexOf('?') > -1 ? '&' : '?') + 'meals=' + S.size + '&frequency=' + S.freq.toLowerCase(); }
  }
  freqs.forEach(function (b) { b.addEventListener('click', function () { S.freq = b.getAttribute('data-freq'); renderBox(); }); });
  tiers.forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) { S.size = Number(b.getAttribute('data-n')); renderBox(); } }); });
  var goBtn = $('#mk2-continue');
  if (goBtn) goBtn.addEventListener('click', function () {
    /* Hand the chosen box to the Menu exactly as the box-size picker's Continue does (sections/box-size-picker.liquid). */
    try {
      var ws = {}; try { ws = JSON.parse(localStorage.getItem('window_state') || '{}') || {}; } catch (e) {}
      var one = S.freq === 'One-time';
      ws.freq = one ? 'OneTimePurchase' : (S.freq === 'Fortnightly' ? 'FortnightlySubscription' : 'WeeklySubscription');
      ws.plan = one ? 'onetime' : 'subscribe';
      ws.boxSize = S.size;
      localStorage.setItem('window_state', JSON.stringify(ws));
      localStorage.setItem('thr1ve_box_target', String(S.size));
      localStorage.setItem('thr1ve_box_chosen', '1');
    } catch (e) {}
  });

  /* ---------- combos: Add combo adds the REAL supplement variant through LocalCart (same call as the menu cards) ---------- */
  var live = document.createElement('div');
  live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
  live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
  root.appendChild(live);
  function addToCart(d) {
    var plan = DATA.sellingPlan || null;
    try {
      if (window.localCart && typeof window.localCart.addItemCondition === 'function') {
        window.localCart.addItemCondition(Number(d.pid), Number(d.vid), d.title, d.url, d.thumb, Number(d.price), Number(d.compare), 1, d.type, plan, null, d.popup, d.ack);
        return Promise.resolve(true);
      }
    } catch (e) { return Promise.resolve(false); }
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(d.vid), quantity: 1 }] })
    }).then(function (r) { return r.ok; }, function () { return false; });
  }
  /* sticky "Go to Menu" bar: revealed only after the first successful add (never before) */
  function showMenuBar() {
    var bar = document.getElementById('mk2-menubar');
    if (!bar || !bar.hidden) return;
    bar.hidden = false; document.body.classList.add('mk2-has-menubar');
  }
  /* hook the real LocalCart add (meal cards, quickview and supplement combos all go through addItem); reveal only when it actually grew the cart */
  function hookLocalCart() {
    var lc = window.localCart;
    if (!lc || typeof lc.addItem !== 'function' || lc.__mk2Wrapped) return;
    lc.__mk2Wrapped = true;
    var orig = lc.addItem;
    var count = function () { return ((lc.cart && lc.cart.items) || []).reduce(function (a, i) { return a + (Number(i.qty) || 0); }, 0); };
    lc.addItem = function () {
      var before = count();
      var r = orig.apply(this, arguments);
      try { if (count() > before) showMenuBar(); } catch (e) {}
      return r;
    };
  }
  hookLocalCart(); window.addEventListener('load', hookLocalCart);
  $$('.mk2-combo-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled || b.getAttribute('aria-pressed') === 'true') return;
      var d = { pid: b.getAttribute('data-pid'), vid: b.getAttribute('data-vid'), title: b.getAttribute('data-title'), url: b.getAttribute('data-url'), thumb: b.getAttribute('data-thumb'), price: b.getAttribute('data-price'), compare: b.getAttribute('data-compare'), type: b.getAttribute('data-type'), popup: b.getAttribute('data-popup') || '', ack: b.getAttribute('data-ack') || '' };
      b.disabled = true; b.textContent = 'Adding…';
      addToCart(d).then(function (ok) {
        if (!ok) { b.disabled = false; b.textContent = 'Try again'; live.textContent = d.title + ' could not be added. Please try again.'; return; }
        b.setAttribute('aria-pressed', 'true'); b.textContent = '✓ Supplement added';
        var card = b.closest('.mk2-combo'); if (card) card.classList.add('mk2-sel');
        S.supps = S.supps || {}; var prev = S.supps[d.vid]; S.supps[d.vid] = { name: b.getAttribute('data-name'), price: Number(d.price) + (prev ? prev.price : 0) };
        var ks = Object.keys(S.supps);
        S.supp = { name: ks.map(function (k) { return S.supps[k].name; }).join(' + '), price: ks.reduce(function (a, k) { return a + S.supps[k].price; }, 0) };
        renderBox();
        live.textContent = d.title + ' added to your box.';
      });
    });
  });

  renderBox();
})();
